// extracted by mini-css-extract-plugin
export default {"desc":"Cover_desc__XfEmd","info":"Cover_info__x21K7","title":"Cover_title__+aGfW","img":"Cover_img__0ui5a","wrap":"Cover_wrap__FYUtL"};